"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const keyBy_1 = tslib_1.__importDefault(require("lodash/keyBy"));
const sumBy_1 = tslib_1.__importDefault(require("lodash/sumBy"));
const getState_1 = require("../../helpers/getState");
const getSuccessStatus_1 = require("../../helpers/getSuccessStatus");
const entity_1 = require("../../type/entity");
const executeRollupRule_1 = require("./executeRollupRule");
/**
 * Updates scaledScore considering
 * contributeToSuccessStatus. Updates successStatus using
 * successStatusRollupRules if node is complete
 */
function updateSuccessStatusFieldsForCurriculum(state, user, content, allStates) {
    // TODO: filter on children offers which have contributeToSuccessStatus as true
    const childrenContents = content.offers;
    const childrenContentIds = childrenContents.map(c => c.offerId);
    const childrenStates = getState_1.getStatesForUserIdAndContentIds(allStates, childrenContentIds, user.userId);
    const childrenStatesByContentId = keyBy_1.default(childrenStates, 'contentId');
    const totalChildrenScaledScore = sumBy_1.default(childrenStates, s => s.scaledScore || 0);
    const totalChildren = childrenContents.length;
    state.scaledScore = totalChildren > 0 ? totalChildrenScaledScore / totalChildren : 0;
    if (state.completionStatus !== entity_1.CompletionStatus.COMPLETE || totalChildren === 0) {
        state.successStatus = entity_1.SuccessStatus.NOT_APPLICABLE;
        return;
    }
    const childrenSuccessStatusArray = childrenContents.map((childContent) => {
        const childContentId = childContent._id;
        const childState = childrenStatesByContentId[childContentId];
        return childState.successStatus;
    });
    let nodeSuccessStatus = entity_1.SuccessStatus.NOT_APPLICABLE;
    const successStatusRollupRules = content.successStatusRollupRules;
    for (const rollupRule of successStatusRollupRules) {
        const { requiredCondition, formula, action } = rollupRule;
        if (executeRollupRule_1.executeRollupRule(childrenSuccessStatusArray, requiredCondition, formula, state.scaledScore)) {
            nodeSuccessStatus = getSuccessStatus_1.getSuccessStatus(action);
            break;
        }
    }
    state.successStatus = nodeSuccessStatus;
}
exports.updateSuccessStatusFieldsForCurriculum = updateSuccessStatusFieldsForCurriculum;
//# sourceMappingURL=updateSuccessStatusFieldsForCurriculum.js.map